// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as CheckboxComponent, FormControlLabel } from '@material-ui/core';
import { CheckboxIcon } from '../Icons';

const Checkbox = ({
  classes,
  value,
  checked,
  disabled,
  label,
  children,
  icon,
  checkedIcon,
  indeterminate,
  ...props
}) => {
  return (
    <FormControlLabel
      label={label || children}
      classes={{
        root: classes.labelRoot,
        label: classes.label,
        disabled: classes.disabled,
      }}
      control={
        <CheckboxComponent
          checked={checked}
          classes={{ root: classes.root }}
          icon={icon || <span className={classes.icon} />}
          checkedIcon={checkedIcon || <CheckboxIcon className={classes.checkedIcon} />}
          color="default"
          value={value}
          indeterminate={indeterminate}
        />
      }
      disabled={disabled}
      {...props}
    />
  );
};

Checkbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The value of the component. */
  value: PropTypes.string,
  /** If true, the component appears selected. */
  checked: PropTypes.bool,
  /** If true, the control will be disabled. */
  disabled: PropTypes.bool,
  /** The text to be used in an enclosing label element. */
  label: PropTypes.node,
  /** The content that will be rendered as label. */
  children: PropTypes.node,
  /** The unchecked icon  */
  icon: PropTypes.node,
  /** The checked icon  */
  checkedIcon: PropTypes.node,
};

Checkbox.defaultProps = {
  classes: {},
  value: '',
  checked: false,
  disabled: false,
  label: null,
  children: null,
  icon: null,
  checkedIcon: null,
};

export default Checkbox;
